import { createSelector } from 'reselect';

export const authByEmailStateSelector = state => state.auth.authByEmail;

export const abeEmailSelector = createSelector(
  authByEmailStateSelector,
  s => s.email
);

export const abePasswordSelector = createSelector(
  authByEmailStateSelector,
  s => s.password
);

export const abeFormErrorsSelector = createSelector(
  authByEmailStateSelector,
  s => s.formErrors
);

export const emailSignInMethodSelector = createSelector(
  authByEmailStateSelector,
  s => s.emailSignInMethod
);

export const resetEmailSendedSelector = createSelector(
  authByEmailStateSelector,
  s => s.resetEmailSended
);